import {hasOfficeAccess} from '@/helpers/portalAccess.helper';
/*
 * To-dos of the QM-Cockpit (source type qualityCase, workflow-manager quality-cases): short summary and a link to the case.
 * To-dos without source show their description as before.
 */
import store from '@/store';
import {LoginTypes} from '@/enums/LoginTypes.enum';
import {QualityCaseToDoSource, ToDoItemSourceTypes} from '@/documentTypes/to-do-manager/ToDoItemSource';
import {CrudEntityTypes} from '@/classes/clientOnly/permissionTreeResources/enums/CrudEntityTypes';
import {CrudActionTypes} from '@/classes/clientOnly/permissionTreeResources/enums/CrudActionTypes';
import CrudAccessManager from '@/classes/clientOnly/permissionTreeResources/classes/CrudAccessManager';

type ToDoLike = { source?: { type?: string } | null } | null | undefined;

export const qualityCaseSourceOf = (item: ToDoLike): QualityCaseToDoSource | null => {
    const source = item?.source as QualityCaseToDoSource | undefined;
    return source && source.type === ToDoItemSourceTypes.QUALITY_CASE && source.caseId ? source : null;
};

/** The QM-Cockpit is never shown to teachers and needs read access to cases (workflow) and students */
export const canOpenQualityCockpit = (): boolean => {
    // Office role, not the flag Employee.isEmployee
    if (store.state.userType !== LoginTypes.EMPLOYEE || !hasOfficeAccess()) {
        return false;
    }
    const crud = store.state.crudAccessManager as CrudAccessManager | null;
    return !!crud?.canAccessType(CrudEntityTypes.WORKFLOW, CrudActionTypes.READ)
        && !!crud?.canAccessType(CrudEntityTypes.STUDENT, CrudActionTypes.READ);
};

/** Location of the case in the QM-Cockpit (`/quality-management?case=…`), null without access */
export const qualityCaseLocation = (source: QualityCaseToDoSource): { path: string; query: { case: string } } | null =>
    canOpenQualityCockpit() ? {path: '/quality-management', query: {case: String(source.caseId)}} : null;
